import i18n from '@dms/i18n';

import {MandatoryFieldType} from '../types/ServiceOrderVariant';

export const VEHICLE_MANDATORY_FIELDS: {id: MandatoryFieldType; label: string}[] = [
  {
    id: 'vehicleRegistrationPlate',
    label: i18n.t('entity.vehicle.labels.licensePlate'),
  },
  {
    id: 'vehicleVin',
    label: i18n.t('entity.vehicle.labels.vin'),
  },
  {
    id: 'vehicleFirstRegistrationOn',
    label: i18n.t('entity.vehicle.labels.firstRegistration'),
  },
  {
    id: 'vehicleWarrantyDate',
    label: i18n.t('entity.vehicle.labels.warrantyUntil'),
  },
  {
    id: 'vehicleTechnicalInspectionValidUntil',
    label: i18n.t('entity.vehicle.labels.inspectionValidUntil'),
  },
];
